/**
 * Splits a translated sentence around its {0}, {1}... placeholders so a template can
 * put a link or a bold word in their place, keeping the sentence one message:
 *
 *   <template v-for="(part, i) in messageParts($t(someKey))" :key="i">
 *     <a v-if="part.slot === 0" href="...">...</a>
 *     <template v-else>{{ part.text }}</template>
 *   </template>
 *
 * Call $t/t with no arguments so the placeholders are still there to split on.
 * Text parts have { text }, placeholders have { slot: n }.
 */
export function messageParts(text) {
  return String(text ?? '')
    .split(/(\{\d+\})/)
    .filter((part) => part !== '')
    .map((part) => {
      const match = /^\{(\d+)\}$/.exec(part);
      return match ? { slot: Number(match[1]) } : { text: part };
    });
}

export default messageParts;
